import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable, catchError, of } from "rxjs";
import { SystemApiService } from "@cv-invision/core";

@Injectable()
export class EmailListService {
	constructor(
		private httpClient: HttpClient,
		private systemApiService: SystemApiService
	) { }

	/**
   * Get a list of available integrations.
   * @returns An Observable of the HTTP response containing the list of integrations.
   */
	getIntegrations(): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}/products/deliveryAsset/integrations`
		);
	}

	/**
   * Retrieve email configurations with optional query parameters.
   * @param params Optional parameters to limit the number of configurations returned.
   * @returns An Observable of the HTTP response containing the email configurations.
   */
	getData(params: { limit?: number } = {}): Observable<any> {
        let httpParams = new HttpParams();
        if (params.limit) {
            httpParams = httpParams.set('limit', params.limit.toString());
        }

        return this.httpClient.get(`${this.systemApiService.api.orders}/utils/email-alert-integration/configs`, { params: httpParams });
    }

	/**
   * Save email configuration.
   * @param data The email configuration data to be saved, including provider and email.
   * @returns An Observable of the HTTP response after saving the configuration.
   */
	saveEmail(data: { provider: string, email: string }): Observable<any> {
		return this.httpClient.post(`${this.systemApiService.api.orders}/utils/email-alert-integration/configs`, data);
	}

	/**
   * Update email configuration by ID.
   * @param id The ID of the email configuration to update.
   * @param data The updated email configuration data.
   * @returns An Observable of the HTTP response.
   */
	updateEmailConfig(id: string, data: any): Observable<any> {
		const url = `${this.systemApiService.api.orders}/utils/email-alert-integration/configs/${id}`;

		return this.httpClient.put(url, data)
			.pipe(
				catchError(error => {
					console.error('Error updating email configuration:', error);
					return of(null);
				})
			);
	}

	/**
   * Delete email configuration by ID.
   * @param id The ID of the email configuration to delete.
   * @returns An Observable of the HTTP response.
   */
	deleteEmailConfig(id: string): Observable<any> {
		const url = `${this.systemApiService.api.orders}/utils/email-alert-integration/configs/${id}`;

		return this.httpClient.delete(url)
			.pipe(
				catchError(error => {
					console.error('Error deleting email:', error);
					return of(null);
				})
			);
	}
}
